// @ts-nocheck
import Fetch from '@/utils/Fetch';
import { colors, layout } from '@/theme';
import { useContext, useEffect, useRef, useState } from 'react';
import Helper from '@/utils/helper';
import SettingsMenu from '@/components/settings/menu';
import ToastContext from '@/utils/toast-context';
import Router from 'next/router';
import Tabs from '@/components/tabs';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import SCComboBox from '@/components/sc-controls/form-controls/sc-combobox';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import SCCheckbox from '@/components/sc-controls/form-controls/sc-checkbox';
import Button from '@/components/button';
import DownloadService from '@/utils/download-service';
import OptionService from '@/services/option/option-service';
import DocumentService from '@/services/document/document-service';
import SCOrientation from '@/components/sc-controls/form-controls/sc-orientation';
import SCRadioButton from '@/components/sc-controls/form-controls/sc-radio-button';
import SCRadioButtonGroup from '@/components/sc-controls/form-controls/sc-radio-button-group';
import messageBarHelper from '@/utils/message-bar-helper';
import SubscriptionContext from '@/utils/subscription-context';
import MessageBarContext from '@/utils/contexts/sc-message-bar-context';
import useDebounce from '@/hooks/useDebounce';
import NewBadge from "@/components/NewBadge";
import { Title, Text, Box } from '@mantine/core'
import { getPaymentAccess } from "@/PageComponents/Payments/payments";
import { useQuery } from "@tanstack/react-query";
import { FieldSetting, getFieldSettings, getCustomerFieldDisplayNames } from "@/PageComponents/Settings/Field Settings/FieldSettings";
import featureService from '@/services/feature/feature-service';
import constants from '@/utils/constants';
import { createFileRoute } from '@tanstack/react-router'



const controlNamesWithNewBadges = [/*'ShowDepositAmount'*//*, 'ShowTotalsAtTheBottom'*/];

const newPaymentsNotification = (
    getPaymentAccess() && <Box mt={'var(--mantine-spacing-lg)'}>
        <Title color={'dimmed'} order={5}><NewBadge /> Payments</Title>
        <Text color={'dimmed'}>Now you can display total payments received and amounts due on your documents.  Update your settings and view the preview.</Text>
    </Box>
)

const newDepositsNotification = (
    getPaymentAccess() && <Box mt={'var(--mantine-spacing-lg)'}>
        <Title color={'dimmed'} order={5}><NewBadge /> Deposits</Title>
        <Text color={'dimmed'}>Now you can display deposit amounts on your documents.  Update your settings and view the preview.</Text>
    </Box>
)

const itemsToCheck = ["UnitOfMeasurement", "InventoryCategory"]

function ManageDocument() {
    const toast = useContext(ToastContext);
    const subscriptionContext = useContext(SubscriptionContext);
    const messageBarContext = useContext(MessageBarContext);
    const debounce = useDebounce();

    const { data: initialDocumentDefinition } = useQuery(
        ['documentDefinition'],
        () => DocumentService.getDocumentDefinition()
    );

    const { data: jobCustomFieldsData } = useQuery(
        ['jobCustomFields'],
        () => Fetch.get({ url: `/Option?module=${Enums.Module.JobCard}` })
    );

    const { data: useLegacyDocumentsProp } = useQuery(
        ['useLegacyDocuments'],
        () => DocumentService.getUseLegacyDocuments()
    );

    const jobCustomFields = jobCustomFieldsData?.Results;

    const [enabledItems, setEnabledItems] = useState<any[]>([]);
    const [hasSections, setHasSections] = useState(false);
    const [hasVanStock, setHasVanStock] = useState(false);

    const inventoryFieldSettings = useQuery(['inventoryFieldSettings'], () => getFieldSettings(Enums.Module.Inventory),
        {
            onSuccess: (data: any) => {
                setEnabledItems(data.filter((x: any) => itemsToCheck.includes(x.FieldSystemName) && x.IsActive).map((x: any) => x.FieldSystemName))
            }
        })

    const customerFieldSettings = useQuery(['customerFieldSettings'], () => getFieldSettings(Enums.Module.Customer),
        {
            onSuccess: (data: any) => {

            }
        })

    const [inventoryGroupOptions, setInventoryGroupOptions] = useState<any[]>([]);

    useEffect(() => {
        let options = [
            ...(enabledItems.includes("InventoryCategory") ? [{ value: Enums.InventoryGroup.Category, label: "Categories" }] : [])
        ];

        if (hasSections) {
            options.push({ value: Enums.InventoryGroup.Section, label: "Sections" });
        }

        setInventoryGroupOptions(options);
    }, [enabledItems, hasSections]);

    let currPath = "";
    if (Router.router) {
        currPath = Router.router.asPath;
    }


    const [selectedTab, setSelectedTab] = useState('Job');
    const [selectedDocumentIndex, setSelectedDocumentIndex] = useState(0);
    const documentRef = useRef<any>(null);
    const [submitting, setSubmitting] = useState(false);
    const [previewing, setPreviewing] = useState(false);
    const [documentDefinition, setDocumentDefinition] = useState<any>(null);
    const [metaData, setMetaData] = useState<any>(null);
    const [formIsDirty, setFormIsDirty] = useState(false);
    const [useLegacyDocuments, setUseLegacyDocuments] = useState<any>(null);

    useEffect(() => {
        if (initialDocumentDefinition && !documentDefinition) {
            setDocumentDefinition(initialDocumentDefinition);
            setMetaData(JSON.parse(initialDocumentDefinition.MetaData));
        }
    }, [initialDocumentDefinition]);

    useEffect(() => {
        if (useLegacyDocumentsProp != null && useLegacyDocuments === null) {
            setUseLegacyDocuments(useLegacyDocumentsProp);
        }
    }, [useLegacyDocumentsProp]);

    const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());
    const logoSizes = [{ value: 80, description: "Smaller" }, { value: 100, description: "Normal" }, { value: 120, description: "Larger" }];

    const getFontSizes = (module: any) => {
        switch (module) {
            case Enums.Module.JobCard:
                return [{ value: 9, description: "Smaller" }, { value: 10, description: "Normal" }, { value: 11, description: "Larger" }];
            default:
                return [{ value: 11, description: "Smaller" }, { value: 12, description: "Normal" }, { value: 13, description: "Larger" }];
        }
    }

    const onSelectedTabChanged = (tab: any) => {

        if (formIsDirty) {
            setConfirmOptions({
                ...Helper.initialiseConfirmOptions(),
                display: true,
                heading: "Save Changes?",
                text: "Save changes before changing the tab?",
                confirmButtonText: "Save Changes",
                discardButtonText: "Discard Changes",
                showDiscard: true,
                showCancel: true,
                onDiscard: async () => {
                    await fetchDocumentDefinition();
                    setSelectedTab(tab);
                },
                onConfirm: async () => {
                    let result = await save();
                    if (result === true) {
                        setSelectedTab(tab);
                    }
                }
            });
            return;
        }

        setSelectedTab(tab);
        setSelectedDocumentIndex(0);
    };

    const fetchDocumentDefinition = async () => {
        let result = await DocumentService.getDocumentDefinition();

        if (result.ID) {
            setFormIsDirty(false);
            setDocumentDefinition(result);
            setMetaData(JSON.parse(result.MetaData));
        }
    }

    const validate = () => {
        let isValid = true;

        let groupByTitle = Helper.groupBy(metaData.JobDocuments.filter((x: any) => x.IsActive && !Helper.isNullOrWhitespace(x.Title)), "Title", true);

        Object.keys(groupByTitle).forEach((title: any) => {
            if (groupByTitle[title].length > 1) {
                isValid = false;
                toast.setToast!!!({
                    message: "Job document titles must be unique",
                    type: Enums.ToastType.error,
                    show: true
                });
            }
        });

        return isValid;
    };

    const upgradeDocuments = async () => {
        setConfirmOptions({
            ...Helper.initialiseConfirmOptions(),
            display: true,
            confirmButtonText: "Upgrade",
            onConfirm: async () => {
                setSubmitting(true);
                let result = await Fetch.post({
                    toastCtx: toast,
                    url: '/DocumentDefinition/Upgrade',
                    params: {
                        OptionValue: false
                    }
                });

                if (result.OptionValue !== undefined && result.OptionValue !== null) {
                    window.localStorage.setItem(Enums.LocalStorage.LegacyDocumentValue, result.OptionValue);
                    messageBarHelper.updateMessageBar(subscriptionContext.subscriptionInfo!!!, messageBarContext);
                    setUseLegacyDocuments(result.OptionValue);
                }

                setSubmitting(false);
            },
            heading: "Upgrade Documents?",
            text: "Confirm you want to upgrade to our new configurable documents. This cannot be undone."
        });
    }

    const preview = async (documentType: any) => {
        setSubmitting(true);
        setPreviewing(true);

        let documentDefinitionToSend = {
            ...documentDefinition,
            MetaData: JSON.stringify(metaData)
        };

        DownloadService.downloadFile('POST', '/DocumentDefinition/Preview', {
            DocumentDefinition: documentDefinitionToSend,
            PreviewDocumentType: documentType
        }, true).then((_: any) => {
            setPreviewing(false);
            setSubmitting(false);
        }, (e: any) => {
            setPreviewing(false);
            setSubmitting(false);
        });


    };

    const save = async () => {

        let isValid = validate();

        if (isValid) {

            setSubmitting(true);

            let documentDefinitionToSend = {
                ...documentDefinition,
                MetaData: JSON.stringify(metaData)
            };

            let result = await Fetch.post({
                toastCtx: toast,
                url: '/DocumentDefinition',
                params: {
                    DocumentDefinition: documentDefinitionToSend
                }
            });

            if (result.ID) {
                setFormIsDirty(false);
                setDocumentDefinition(result);
                setMetaData(JSON.parse(result.MetaData));
                toast.setToast!!!({
                    message: "Document Definition saved successfully",
                    type: Enums.ToastType.success,
                    show: true
                });
            }
            else {
                isValid = false;
            }

            setSubmitting(false);
        }

        return isValid;
    };

    useEffect(() => {
        featureService.getFeature(constants.features.INVENTORY_SECTION_BUNDLE).then((feature: any) => {
            setHasSections(!!feature);
        });
        featureService.getFeature(constants.features.VAN_STOCK).then((feature: any) => {
            setHasVanStock(!!feature);
        });
    }, []);


    function sortDocuments(documentsToSort: any) {
        return documentsToSort.sort((a: any, b: any) => a.DisplayOrder - b.DisplayOrder);
    }

    const plotConfiguration = (module: any) => {

        let documentModuleKey = "";
        let hasTitle = true;
        let hasOrientation = true;
        let showOrientation = false;
        let hasSizing = true;
        let showDocument = false;
        let showCustomerZonePrintable = false;
        let showCompactMode = false;

        switch (module) {
            case Enums.Module.JobCard:
                showDocument = true;
                showOrientation = true;
                documentModuleKey = "JobDocuments";
                showCustomerZonePrintable = true;
                showCompactMode = true;
                break;
            case Enums.Module.Quote:
                documentModuleKey = "QuoteDocuments";
                break;
            case Enums.Module.Invoice:
                documentModuleKey = "InvoiceDocuments";
                break;
            case Enums.Module.PurchaseOrder:
                documentModuleKey = "PurchaseOrderDocuments";
                break;
        }

        let documents = sortDocuments(metaData[documentModuleKey].filter((x: any) => x.IsActive));

        if (documents.length < selectedDocumentIndex + 1) {
            if (documents.length > 0) {
                setSelectedDocumentIndex(0);
            }
            return <></>;
        }

        documentRef.current = documents[selectedDocumentIndex];

        const onSelectedDocumentChange = (document: any) => {
            if (!document) {
                setSelectedDocumentIndex((idx: any) => idx);
            } else {
                let idx = documents.findIndex((x: any) => x.DocumentType === document.DocumentType);
                setSelectedDocumentIndex(idx);
            }
        };

        const updateInput = (e: any) => {
            let metaDataTemp = { ...metaData };
            let documentTemp = { ...documentRef.current };

            // prop names can be in csv format
            e.name.split(",").forEach((eName: any) => {
                documentTemp[eName] = e.value;
            });

            for (let i in metaDataTemp[documentModuleKey]) {
                if (metaDataTemp[documentModuleKey][i].DocumentType === documentTemp.DocumentType) {
                    metaDataTemp[documentModuleKey][i] = documentTemp;
                }
            }

            setMetaData(metaDataTemp);
            documentRef.current = documentTemp;
            setFormIsDirty(true);
        };

        const canAddDocument = () => {
            let cnt = metaData[documentModuleKey].filter((x: any) => !x.IsActive).length;
            return cnt > 0;
        };

        const canRemoveDocument = () => {
            let cnt = metaData[documentModuleKey].filter((x: any) => x.IsActive).length;
            return cnt > 1;
        };

        const addDocument = () => {
            if (!canAddDocument()) return;
            if (!debounce.canProceed(500)) return;

            let metaDataTemp = { ...metaData };
            let documentsForActivation = sortDocuments(metaDataTemp[documentModuleKey]);
            let idx = documentsForActivation.findIndex((x: any) => !x.IsActive);
            if (idx < 0) return;
            documentsForActivation[idx].IsActive = true;
            setMetaData(metaDataTemp);
            setFormIsDirty(true);
            setSelectedDocumentIndex(idx);
            documentRef.current = documentsForActivation[idx];
        };

        const removeDocument = () => {
            if (!canRemoveDocument()) return;
            if (!debounce.canProceed(500)) return;

            let metaDataTemp = { ...metaData };
            let documentsForDeactivation = sortDocuments(metaDataTemp[documentModuleKey]);

            let selectedDocumentType = documents[selectedDocumentIndex].DocumentType;
            let indexToDeactivate = documentsForDeactivation.findIndex((x: any) => x.DocumentType === selectedDocumentType);
            documentsForDeactivation[indexToDeactivate].IsActive = false;
            setMetaData(metaDataTemp);
            setFormIsDirty(true);
            let idx = 0;
            setSelectedDocumentIndex(idx);
            documentRef.current = documents.filter((x: any) => x.DocumentType !== selectedDocumentType)[idx];

        };

        const updateOrientation = (orientation: any) => {
            let orientationValue = orientation.value;
            updateInput({ name: "Orientation", value: orientationValue });
        };

        const updateFontSize = (fontSize: any) => {
            let fontSizeValue = fontSize.value;
            updateInput({ name: "FontSize", value: fontSizeValue });
        };

        const updateLogoSize = (logoSize: any) => {
            let logoSizeValue = logoSize.value;
            updateInput({ name: "LogoSize", value: logoSizeValue });
        };

        const plotSetting = (settingKey: any, key: any) => {
            let label = settingKey.label;
            let parent = settingKey.parent;
            let keyName = settingKey.name.split(",")[0];
            let value = documentRef.current[keyName];
            let options = settingKey.options;
            let disabled = settingKey.isDisabled;
            let unchecked = settingKey.isDisabled;
            const showNewBadge = settingKey.showNewBadge;
            if (parent && !settingKey.isDisabled) {
                disabled = !documentRef.current[parent];
            }
            if (Array.isArray(options)) {
                return (<>
                    <SCRadioButtonGroup
                        name={keyName}
                        key={key}
                        value={value}
                        onChange={updateInput}
                        valueOutputConverter={(e: any) => parseInt(e)}
                        orientation="vertical"
                    >
                        {options.map((opt: any, keyInner: any) => {
                            return (
                                <div key={`${key}x${keyInner}x`} className={parent ? "tabbed" : ""}>
                                    <SCRadioButton
                                        disabled={disabled}
                                        label={opt.label}
                                        value={opt.value}
                                    />
                                </div>
                            );
                        })}
                    </SCRadioButtonGroup>

                    <style jsx>{`
                      .tabbed {
                        margin-left: 1rem;
                      }
                    `}</style>
                </>);
            } else {
                return (
                    <div
                        style={{
                            marginLeft: parent ? '1rem' : '',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        }}
                        key={key + '-check'}
                    >
                        <div>
                            <SCCheckbox
                                label={label}
                                value={!unchecked && value}
                                name={settingKey.name}
                                onChangeFull={updateInput}
                                key={key}
                                disabled={disabled}
                            />
                        </div>

                        {
                            controlNamesWithNewBadges.includes((settingKey as any).name) &&
                            <span style={{ marginTop: 11 }}>
                                <NewBadge />
                            </span>
                        }
                    </div>
                );
            }
        };

        const plotSettingColumn = (settingKeys: any) => {
            return settingKeys.map((settingKey: any, key: any) => {
                return plotSetting(settingKey, key);
            });
        }

        const getSetting = (name: any, label: any, parent = null, options = null, isDisabled = false) => {
            return {
                name, label, parent, options, isDisabled
            };
        }

        const plotJobSettings = () => {
            let { fieldLabel1, fieldLabel2, fieldLabel3, fieldLabel4, dateFieldLabel1, dateFieldLabel2, filterFieldLabel1, filterFieldLabel2, numberFieldLabel1, numberFieldLabel2 } =
                OptionService.getJobCustomFields(jobCustomFields);

            let {
                fieldLabel1: customerFieldLabel1,
                fieldLabel2: customerFieldLabel2,
                fieldLabel3: customerFieldLabel3,
                fieldLabel4: customerFieldLabel4,
                dateFieldLabel1: customerDateFieldLabel1,
                dateFieldLabel2: customerDateFieldLabel2,
                filterFieldLabel1: customerFilterFieldLabel1,
                filterFieldLabel2: customerFilterFieldLabel2,
                numberFieldLabel1: customerNumberFieldLabel1,
                numberFieldLabel2: customerNumberFieldLabel2
            } = customerFieldSettings?.data ? getCustomerFieldDisplayNames(customerFieldSettings.data) : {
                fieldLabel1: 'CustomField1',
                fieldLabel2: 'CustomField2',
                fieldLabel3: 'CustomField3',
                fieldLabel4: 'CustomField4',
                filterFieldLabel1: 'CustomFilter1',
                filterFieldLabel2: 'CustomFilter2',
                dateFieldLabel1: 'CustomDate1',
                dateFieldLabel2: 'CustomDate2',
                numberFieldLabel1: 'CustomNumber1',
                numberFieldLabel2: 'CustomNumber2'
            };

            return (<>

                <div>
                    <h4>Select document information</h4>
                </div>

                <div className="row">
                    <div className="column">
                        <div className="padding-right border-right">
                            <div className="section-heading">
                                Header Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowLogo", "Logo"),
                                getSetting("ShowBarcode", "Barcode"),
                                getSetting("RepeatableHeader", "Header is Repeated"),
                                getSetting("ShowCompanyDetails", "Company Details"),
                                getSetting("ShowCompanyPostalAddress", "Postal Address", ("ShowCompanyDetails" as any)),
                                getSetting("ShowCompanyRegistrationNumber", "Company Registration Number", ("ShowCompanyDetails" as any)),
                                getSetting("ShowCompanyVATNumber", "VAT Number", ("ShowCompanyDetails" as any))
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right">
                            <div className="section-heading">
                                Customer Details
                            </div>
                            <div className="scrollable">
                                {plotSettingColumn([
                                    getSetting("ShowCustomerCode", "Customer Code"),
                                    getSetting("ShowCustomerName", "Customer Name"),
                                    getSetting("ShowContactName", "Contact Name"),
                                    getSetting("ShowContactEmail", "Email"),
                                    getSetting("ShowContactMobile", "Mobile Number"),
                                    getSetting("ShowAddress", "Address"),
                                    getSetting("ShowAddressDescription", "Address Name", ("ShowAddress" as any))
                                ])}

                                <div className="section-heading margin-top">
                                    Customer Custom Details
                                </div>

                                {plotSettingColumn([
                                    getSetting("ShowCustomerCustomField1", customerFieldLabel1),
                                    getSetting("ShowCustomerCustomField2", customerFieldLabel2),
                                    getSetting("ShowCustomerCustomField3", customerFieldLabel3),
                                    getSetting("ShowCustomerCustomField4", customerFieldLabel4),
                                    getSetting("ShowCustomerCustomNumber1", customerNumberFieldLabel1),
                                    getSetting("ShowCustomerCustomNumber2", customerNumberFieldLabel2),
                                    getSetting("ShowCustomerCustomFilter1", customerFilterFieldLabel1),
                                    getSetting("ShowCustomerCustomFilter2", customerFilterFieldLabel2),
                                    getSetting("ShowCustomerCustomDate1", customerDateFieldLabel1),
                                    getSetting("ShowCustomerCustomDate2", customerDateFieldLabel2)
                                ])}
                            </div>

                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right border-left border-right">
                            <div className="section-heading">
                                Job Details
                            </div>
                            <div className="scrollable">
                                {plotSettingColumn([
                                    getSetting("ShowEmployees", "Assigned employees"),
                                    ...(true ? [getSetting("ShowVan", "Assigned Van"),] : []),
                                    getSetting("ShowInventoryWorkedOn", "Customer Assets"),
                                    getSetting("ShowCustomField1", fieldLabel1),
                                    getSetting("ShowCustomField2", fieldLabel2),
                                    getSetting("ShowCustomField3", fieldLabel3),
                                    getSetting("ShowCustomField4", fieldLabel4),
                                    getSetting("ShowCustomNumber1", numberFieldLabel1),
                                    getSetting("ShowCustomNumber2", numberFieldLabel2),
                                    getSetting("ShowCustomFilter1", filterFieldLabel1),
                                    getSetting("ShowCustomFilter2", filterFieldLabel2),
                                    getSetting("ShowCustomDate1", dateFieldLabel1),
                                    getSetting("ShowCustomDate2", dateFieldLabel2),
                                    getSetting("ShowAccessories", "Accessories"),
                                    getSetting("ShowAssessmentFee", "Assessment Fee"),
                                    getSetting("ShowFaultCauses", "Fault Causes"),
                                    getSetting("ShowFaultCodes", "Fault Codes"),
                                    getSetting("ShowFaultReasons", "Fault Reasons"),
                                    getSetting("ShowPreviousJobNumber", "Previous Job Number"),
                                    getSetting("ShowReferenceNumber", "Reference Number"),
                                    getSetting("ShowSupplier", "Supplier")
                                ])}
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left">
                            <div className="section-heading">
                                Additional Details
                            </div>
                            <div className="scrollable">
                                {plotSettingColumn([
                                    getSetting("ShowInventoryUsed", "Materials"),
                                    getSetting("ShowInventoryType", "Show Type", ("ShowInventoryUsed" as any)),
                                    getSetting("ShowInventoryUnitOfMeasurement", "Show Unit", ("ShowInventoryUsed" as any), null, !enabledItems.includes("UnitOfMeasurement")),
                                    getSetting("ShowInventoryUsedDisplayImage", "Display Image", ("ShowInventoryUsed" as any)),
                                    getSetting("GroupInventory", "Group Materials by", null, null, inventoryGroupOptions?.length === 0),
                                    getSetting("InventoryGroup", "Group", ("GroupInventory" as any), (inventoryGroupOptions as any), inventoryGroupOptions?.length === 0),
                                    getSetting("ShowBlankMaterialsUsed", "Blank Materials Used"),
                                    getSetting("ShowQuotes", "Quotes"),
                                    getSetting("ShowInvoices", "Invoices"),
                                    getSetting("ShowAppointments", "Appointments"),
                                    getSetting("ShowTimers", "Timers"),
                                    getSetting("ShowTimersBillable", "Billable Column", ("ShowTimers" as any)),
                                    getSetting("ShowTimersOvertime", "Overtime Column", ("ShowTimers" as any)),
                                    getSetting("ShowTimersSLA", "SLAtime Column", ("ShowTimers" as any)),
                                    getSetting("ShowTasks", "Tasks"),
                                    getSetting("ShowJobSummary", "Job Summary"),
                                    getSetting("ShowCommentsInternal", "Internal Comments"),
                                    getSetting("ShowCommentsExternal", "Public Comments"),
                                    getSetting("ShowAttachments", "Attached Images"),
                                    getSetting("ShowSignatures", "Signatures"),
                                    getSetting("ShowTerms", "Terms"),
                                    getSetting("ShowJobForms", "Job Forms"),
                                    getSetting("ShowCustomerForms", "Customer Forms")
                                ])}
                            </div>
                        </div>
                    </div>
                </div>

                <style jsx>{`
                
                .row {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  }

                  .column {
                    display: flex;
                    flex-direction: column;
                    width: ${layout.inputWidth};
                  }

                  .section-heading {
                    font-weight: bold;
                    font-size: 1rem;
                    padding: 0.5rem;
                    background: #f0f0f0;
                    margin-bottom: 0.5rem;
                  }

                  .padding-left {
                    padding-left: 1rem;
                  }

                  .padding-right {
                    padding-right: 1rem;
                  }

                  .margin-top {
                    margin-top: 1rem;
                  }

                  .border-right {
                    border-right: 1px solid black;
                  }

                  .border-left {
                    border-left: 1px solid black;
                  }

                  .scrollable {
                    max-height: 274px;
                    overflow: auto;
                    -ms-overflow-style: none;
                    //scrollbar-width: none;
                  }
  
                  .scrollable::-webkit-scrollbar {
                      width: 6px;
                      background: #f0f0f0;
                    }
                    .scrollable::-webkit-scrollbar-thumb {
                      width: 6px;
                      background: lightgrey;
                    }
                
                `}</style>

            </>);
        };

        const plotQuoteSettings = () => {

            return (<>

                {
                    /*newDepositsNotification*/
                }

                <div>
                    <h4>Select document information</h4>
                </div>

                <div className="row">
                    <div className="column">
                        <div className="padding-right">
                            <div className="section-heading">
                                Company Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCompanyPostalAddress", "Postal Address"),
                                getSetting("ShowCompanyRegistrationNumber", "Company Registration Number"),
                                getSetting("ShowCompanyVATNumber", "VAT Number")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right border-left">
                            <div className="section-heading">
                                Customer Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCustomerLocation", "Primary Location"),
                                getSetting("CustomerLocationType", "Type", ("ShowCustomerLocation" as any), [{ value: Enums.LocationType.Delivery, label: "Delivery" }, { value: Enums.LocationType.Postal, label: "Postal" }]),
                                getSetting("ShowCustomerCompanyRegistrationNumber", "Company Registration Number"),
                                getSetting("ShowCustomerVATNumber", "VAT Number")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right border-left">
                            <div className="section-heading">
                                Line Item
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCodeLineItem", "Code"),
                                getSetting("ShowUnitOfMeasurementLineItem", "Unit", null, null, !enabledItems.includes("UnitOfMeasurement")),
                                getSetting("ShowQtyLineItem", "Quantity"),
                                getSetting("ShowUnitPriceLineItem", "Price"),
                                getSetting("ShowDiscountPercentageLineItem", "Discount %"),
                                getSetting("ShowTotalExclLineItem", "Total Excluding"),
                                getSetting("ShowVATLineItem", "VAT"),
                                getSetting("ShowTotalInclLineItem", "Total"),
                                getSetting("ShowDisplayImage", "Display Image")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left border-left">
                            <div className="section-heading">
                                Additional Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowReferenceNumber", "Reference Number"),
                                getSetting("ShowCustomerCode", "Customer Code"),
                                getSetting("ShowSalesRep", "Sales Rep"),
                                getSetting("ShowSalesRepPhoneNumber", "Phone Number", ("ShowSalesRep" as any)),
                                getSetting("ShowSalesRepEmail", "Email", ("ShowSalesRep" as any)),
                                getSetting("ShowLinkedItem", "Linked Item"),
                                getSetting("ShowPayments", "Payments"),
                                getSetting("ShowDepositAmount", "Deposits")
                            ])}

                            <div className="section-heading margin-top">
                                Totals
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowTotalExcl", "Total Excluding"),
                                getSetting("ShowTotalVAT", "Total VAT"),
                                getSetting("ShowTotalsAtTheBottom", "Totals at the Bottom"),
                                getSetting("ShowBankDetails", "Bank Details")
                            ])}
                        </div>
                    </div>
                </div>

                <style jsx>{`
                
                .row {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  }

                  .column {
                    display: flex;
                    flex-direction: column;
                    width: ${layout.inputWidth};
                  }

                  .section-heading {
                    font-weight: bold;
                    font-size: 1rem;
                    padding: 0.5rem;
                    background: #f0f0f0;
                    margin-bottom: 0.5rem;
                  }

                  .padding-left {
                    padding-left: 1rem;
                  }

                  .padding-right {
                    padding-right: 1rem;
                  }

                  .margin-top {
                    margin-top: 1rem;
                  }

                  .border-right {
                    border-right: 1px solid black;
                  }

                  .border-left {
                    border-left: 1px solid black;
                  }
                
                `}</style>

            </>);
        };

        const plotInvoiceSettings = () => {

            return (<>

                {
                    // newPaymentsNotification
                }

                <div>
                    <h4>Select document information</h4>
                </div>

                <div className="row">
                    <div className="column">
                        <div className="padding-right">
                            <div className="section-heading">
                                Company Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCompanyPostalAddress", "Postal Address"),
                                getSetting("ShowCompanyRegistrationNumber", "Company Registration Number"),
                                getSetting("ShowCompanyVATNumber", "VAT Number")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right border-left">
                            <div className="section-heading">
                                Customer Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCustomerLocation", "Primary Location"),
                                getSetting("CustomerLocationType", "Type", ("ShowCustomerLocation" as any), [{ value: Enums.LocationType.Delivery, label: "Delivery" }, { value: Enums.LocationType.Postal, label: "Postal" }]),
                                getSetting("ShowCustomerCompanyRegistrationNumber", "Company Registration Number"),
                                getSetting("ShowCustomerVATNumber", "VAT Number")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right border-left">
                            <div className="section-heading">
                                Line Item
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCodeLineItem", "Code"),
                                getSetting("ShowUnitOfMeasurementLineItem", "Unit", null, null, !enabledItems.includes("UnitOfMeasurement")),
                                getSetting("ShowQtyLineItem", "Quantity"),
                                getSetting("ShowUnitPriceLineItem", "Price"),
                                getSetting("ShowDiscountPercentageLineItem", "Discount %"),
                                getSetting("ShowTotalExclLineItem", "Total Excluding"),
                                getSetting("ShowVATLineItem", "VAT"),
                                getSetting("ShowTotalInclLineItem", "Total"),
                                getSetting("ShowDisplayImage", "Display Image")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left border-left">
                            <div className="section-heading">
                                Additional Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowReferenceNumber", "Reference Number"),
                                getSetting("ShowCustomerCode", "Customer Code"),
                                getSetting("ShowSalesRep", "Sales Rep"),
                                getSetting("ShowSalesRepPhoneNumber", "Phone Number", ("ShowSalesRep" as any)),
                                getSetting("ShowSalesRepEmail", "Email", ("ShowSalesRep" as any)),
                                getSetting("ShowLinkedItem", "Linked Item"),
                                getSetting("ShowPayments", "Payments")
                            ])}

                            <div className="section-heading margin-top">
                                Totals
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowTotalExcl", "Total Excluding"),
                                getSetting("ShowTotalVAT", "Total VAT"),
                                getSetting("ShowTotalsAtTheBottom", "Totals at the Bottom"),
                                getSetting("ShowBankDetails", "Bank Details")
                            ])}
                        </div>
                    </div>
                </div>

                <style jsx>{`

                .row {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  }

                  .column {
                    display: flex;
                    flex-direction: column;
                    width: ${layout.inputWidth};
                  }

                  .section-heading {
                    font-weight: bold;
                    font-size: 1rem;
                    padding: 0.5rem;
                    background: #f0f0f0;
                    margin-bottom: 0.5rem;
                  }

                  .padding-left {
                    padding-left: 1rem;
                  }

                  .padding-right {
                    padding-right: 1rem;
                  }

                  .margin-top {
                    margin-top: 1rem;
                  }

                  .border-right {
                    border-right: 1px solid black;
                  }

                  .border-left {
                    border-left: 1px solid black;
                  }

                `}</style>

            </>);
        };

        const plotPurchaseOrderSettings = () => {

            return (<>

                <div>
                    <h4>Select document information</h4>
                </div>

                <div className="row">
                    <div className="column">
                        <div className="padding-right border-right">
                            <div className="section-heading">
                                Company Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCompanyPostalAddress", "Postal Address"),
                                getSetting("ShowCompanyRegistrationNumber", "Company Registration Number"),
                                getSetting("ShowCompanyVATNumber", "VAT Number")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right">
                            <div className="section-heading">
                                Supplier Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowSupplierVATNumber", "VAT Number")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left padding-right border-left">
                            <div className="section-heading">
                                Line Item
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowCodeLineItem", "Code"),
                                getSetting("ShowUnitOfMeasurementLineItem", "Unit", null, null, !enabledItems.includes("UnitOfMeasurement")),
                                getSetting("ShowQtyLineItem", "Quantity"),
                                getSetting("ShowUnitPriceLineItem", "Price"),
                                getSetting("ShowDiscountPercentageLineItem", "Discount %"),
                                getSetting("ShowTotalExclLineItem", "Total Excluding"),
                                getSetting("ShowVATLineItem", "VAT"),
                                getSetting("ShowTotalInclLineItem", "Total"),
                                getSetting("ShowDisplayImage", "Display Image")
                            ])}
                        </div>
                    </div>
                    <div className="column">
                        <div className="padding-left border-left">
                            <div className="section-heading">
                                Additional Details
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowReferenceNumber", "Reference Number"),
                                getSetting("ShowSalesRep", "Sales Rep"),
                                getSetting("ShowSalesRepPhoneNumber", "Phone Number", ("ShowSalesRep" as any)),
                                getSetting("ShowSalesRepEmail", "Email", ("ShowSalesRep" as any)),
                                getSetting("ShowLinkedItem", "Linked Item"),
                                getSetting("ShowNotes", "Notes")
                            ])}

                            <div className="section-heading margin-top">
                                Totals
                            </div>

                            {plotSettingColumn([
                                getSetting("ShowTotalExcl", "Total Excluding"),
                                getSetting("ShowTotalVAT", "Total VAT"),
                                getSetting("ShowTotalsAtTheBottom", "Totals at the Bottom")
                            ])}
                        </div>
                    </div>
                </div>

                <style jsx>{`
                
                .row {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  }

                  .column {
                    display: flex;
                    flex-direction: column;
                    width: ${layout.inputWidth};
                  }

                  .section-heading {
                    font-weight: bold;
                    font-size: 1rem;
                    padding: 0.5rem;
                    background: #f0f0f0;
                    margin-bottom: 0.5rem;
                  }

                  .padding-left {
                    padding-left: 1rem;
                  }

                  .padding-right {
                    padding-right: 1rem;
                  }

                  .margin-top {
                    margin-top: 1rem;
                  }

                  .border-right {
                    border-right: 1px solid black;
                  }

                  .border-left {
                    border-left: 1px solid black;
                  }
                
                `}</style>

            </>);
        };

        return (<>
            {showDocument ?
                <div className="row">
                    <div className="column">
                        <div className="row left-justified">
                            <div className="input-width">
                                <SCComboBox
                                    canClear={false}
                                    canSearch={false}
                                    label={"Document Style Name"}
                                    options={documents}
                                    value={documents[selectedDocumentIndex]}
                                    onChange={onSelectedDocumentChange}
                                    dataItemKey={"DocumentType"}
                                    textField={"Title"}
                                    filter={documents[selectedDocumentIndex].Title}
                                    disabled={false}
                                />
                            </div>
                            {canAddDocument() ?
                                <div className="add-document-img">
                                    <img src="/icons/plus-circle-blue.svg" height="24" onClick={addDocument} />
                                </div>
                                : ""}
                        </div>
                    </div>
                    <div className="column" style={{ paddingTop: "2.5rem" }}>
                        <span>Follow <a href="https://docs.google.com/document/d/e/2PACX-1vQSGcjsk0DOzM63oXA4MiLmzHQI9u35eZVgdTb6bNs68xhSNUArYGSGCDwkR1a5tPnsKjleT4mX6v7c/pub" target="_blank">this link</a> to find out how to use ServCraft's new documents.</span>
                    </div>
                    <div className="column">
                    </div>
                </div>
                : ""
            }
            <div className={module === Enums.Module.JobCard ? "bordered-container" : ""}>

                <div className="row ">
                    <div className="column">
                        <h4 className="small-margin">Stylise Document</h4>
                        <div className="row">
                            {hasTitle ? <div className="column">
                                <SCInput
                                    label={"Title"}
                                    value={documentRef.current.Title}
                                    name={"Title"}
                                    onChange={updateInput}
                                />
                            </div>
                                : ""}
                            {hasOrientation && showOrientation ? <>
                                <div className="column left-padding orientation">
                                    <SCOrientation
                                        name="Orientation"
                                        value={documentRef.current.Orientation}
                                        onChange={updateOrientation}
                                    />
                                </div>
                            </> : ""}
                        </div>
                        {hasSizing ? <div className="row" style={{ width: "640px" }}>
                            <div className="column">
                                <SCComboBox
                                    canClear={false}
                                    canSearch={false}
                                    label={"Logo Size"}
                                    options={logoSizes}
                                    value={logoSizes.find((x: any) => x.value === documentRef.current.LogoSize)}
                                    onChange={updateLogoSize}
                                    name="LogoSize"
                                    dataItemKey={"value"}
                                    textField={"description"}
                                    filter={logoSizes.find((x: any) => x.value == documentRef.current.LogoSize).description}
                                    disabled={documentRef.current.IsCompact}
                                />
                            </div>
                            <div className="column left-padding">
                                <SCComboBox
                                    canClear={false}
                                    canSearch={false}
                                    label={"Font Size"}
                                    options={getFontSizes(module)}
                                    value={getFontSizes(module).find((x: any) => x.value === documentRef.current.FontSize)}
                                    onChange={updateFontSize}
                                    name="FontSize"
                                    dataItemKey={"value"}
                                    textField={"description"}
                                    filter={getFontSizes(module).find((x: any) => x.value == documentRef.current.FontSize).description}
                                    disabled={documentRef.current.IsCompact}
                                />

                            </div>


                        </div>
                            : ""}


                    </div>

                    <div>

                        <div className="row margin-top">
                            {canRemoveDocument() ?
                                <div className="remove-document-img">
                                    <img src="/icons/trash-bluegrey.svg" height="24" onClick={removeDocument} />
                                </div>
                                : ""}
                            <div>
                                <Button
                                    disabled={submitting}
                                    text={previewing ? "Generating..." : "Preview"}
                                    extraClasses="fit-content auto no-margin hollow"
                                    onClick={() => preview(documentRef.current.DocumentType)}
                                />
                            </div>
                            <div className="margin-left">
                                <Button
                                    disabled={!formIsDirty || submitting}
                                    text={submitting ? "Saving..." : "Save"}
                                    extraClasses="fit-content auto no-margin"
                                    onClick={save}
                                />
                            </div>
                        </div>
                        <div className="row flex-align-right">
                            <SCCheckbox
                                labelPlacement={"before"}
                                value={documentRef.current.PDFStrictMode}
                                label="PDF Strict Mode"
                                onChange={() => {
                                    updateInput({ name: "PDFStrictMode", value: !documentRef.current.PDFStrictMode });
                                }}
                            />
                        </div>
                        <div className="row flex-align-right">
                            {showCustomerZonePrintable ?
                                <SCCheckbox
                                    labelPlacement={"before"}
                                    value={documentRef.current.CustomerZonePrintable}
                                    label="Available on Customer Zone"
                                    onChange={() => {
                                        updateInput({ name: "CustomerZonePrintable", value: !documentRef.current.CustomerZonePrintable });
                                    }}
                                />
                                : <></>}
                        </div>
                        <div className="row flex-align-right">
                            {showCompactMode ?
                                <SCCheckbox
                                    labelPlacement={"before"}
                                    value={documentRef.current.IsCompact}
                                    label="Compact View"
                                    onChange={() => {
                                        updateInput({ name: "IsCompact", value: !documentRef.current.IsCompact });
                                    }}
                                />
                                : <></>}
                        </div>

                    </div>
                </div>


                <div>
                    {module === Enums.Module.Quote ? <>{plotQuoteSettings()}</> :
                        module === Enums.Module.Invoice ? <>{plotInvoiceSettings()}</> :
                            module === Enums.Module.PurchaseOrder ? <>{plotPurchaseOrderSettings()}</> :
                                module === Enums.Module.JobCard ? <>{plotJobSettings()}</> :
                                    ""}
                </div>
            </div>

            <style jsx>{`
                 .row {
                    display: flex;
                    justify-content: space-between;
                  }

                  .row.left-justified {
                    justify-content: start;
                  }

                  .column {
                    display: flex;
                    flex-direction: column;
                    width: ${layout.inputWidth};
                  }

                  .margin-left {
                    margin-left: 0.5rem;
                  }

                  .margin-top {
                    margin-top: 0.5rem;
                  }

                  .flex-align-right {
                    flex-flow: row-reverse;
                  }

                  .preview-container {
                    height: 23.2rem;
                    width: 16.8rem;
                    background-color: ${colors.blueDark}11;
                    border-radius: 3px;
                    margin-top: 1rem;
                    margin-left: 1rem;
                    position: relative;
                  }

                  .preview-button {
                    width: fit-content;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                  }

                  .right-padding {
                    padding-right: 0.5rem;
                  }
                  
                  .left-padding {
                    padding-left: 0.5rem;
                  }

                  .add-document-img {
                    padding: 2.6rem 0.5rem 0 0.5rem;
                  }

                  .remove-document-img {
                    padding: 0.5rem;
                    display: inline-block;
                  }

                  .add-document-img img, .remove-document-img {
                    cursor: pointer;
                  }

                  .bordered-container {
                    // border: 1px solid ${colors.blueGreyLight}88;
                    padding: 0.5rem 1rem 1rem 1rem;
                    border-radius: ${layout.bodyRadius};
                    margin-top: 1rem;
                    box-shadow: 0 0 0.5rem ${colors.blueGreyLight}99;
                  }

                  h4.small-margin {
                    margin: 0.5rem 0 0 0;
                  }

                  .input-width {
                    width: 258px;
                    display: inline-block;
                  }

                  .orientation {
                    margin-top: 1rem;
                  }
                  
            `}</style>
        </>);
    };


    Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, save);

    if (!documentDefinition || !metaData) return null;

    return (
        <div className="settings-container">
            {/*<div className="row">
                <div className="title">
                    <Breadcrumbs
                        crumbs={[
                            { text: 'Settings', link: '/settings', suppressLink: true },
                            { text: 'Documents', link: '/settings/document/manage' },
                        ]}
                    />
                </div>
            </div>*/}
            <div className="row">
                <SettingsMenu urlPath={currPath} />
                <div className="settings-card">


                    {useLegacyDocuments ? <>
                        <h3>You are using legacy documents</h3>
                        <p>Want to upgrade to our new job and financial documents? They are highly customisable and look great!</p>
                        <p>Follow <a href="https://docs.google.com/document/d/e/2PACX-1vQSGcjsk0DOzM63oXA4MiLmzHQI9u35eZVgdTb6bNs68xhSNUArYGSGCDwkR1a5tPnsKjleT4mX6v7c/pub" target="_blank">this link</a> to find out how to use ServCraft's new documents.</p>
                        <Button
                            text="Upgrade Here"
                            extraClasses="auto fit-content"
                            onClick={upgradeDocuments}
                        />
                    </> : <>

                        <Tabs
                            smallMarginTop={true}
                            selectedTab={selectedTab}
                            setSelectedTab={onSelectedTabChanged}
                            tabs={[
                                { text: 'Job', suppressCount: true },
                                { text: 'Quote', suppressCount: true },
                                { text: 'Invoice', suppressCount: true },
                                { text: 'Purchase Order', suppressCount: true }
                            ]} />
                        {(() => {
                            switch (selectedTab) {
                                case 'Job':
                                    return (
                                        <>
                                            {plotConfiguration(Enums.Module.JobCard)}
                                        </>
                                    );
                                case 'Quote':
                                    return (
                                        <>
                                            {plotConfiguration(Enums.Module.Quote)}
                                        </>
                                    );
                                case 'Invoice':
                                    return (
                                        <>
                                            {plotConfiguration(Enums.Module.Invoice)}
                                        </>
                                    );
                                case 'Purchase Order':
                                    return (
                                        <>
                                            {plotConfiguration(Enums.Module.PurchaseOrder)}
                                        </>
                                    );
                                default:
                                    return null;
                            }
                        })()}
                    </>}


                </div>
            </div>

            <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

            <style jsx>{`
            .row {
              display: flex;
              justify-content: space-between;
            }
            .column {
              display: flex;
              flex-direction: column;
              width: ${layout.inputWidth};
            }
            .column-end {
              align-items: flex-end;
            }
            .column-margin {
              margin-left: 0.5rem;
            }
           
            .title {
              color: ${colors.darkPrimary};
              position: relative;
              width: 100%;
            }
            .title h1 {
              font-size: 24px;
              margin: 6px 0 2rem 0;
            }
            .title p {
              font-size: 14px;
              margin: 0;
            }                
            h2 {
              color: ${colors.darkPrimary};
              font-size: 1.75rem;
              font-weight: lighter;
              margin: 1rem 0 -1rem;
            }
            .section-title {
              background-color: ${colors.background};
              border-radius: ${layout.cardRadius};
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
              color: ${colors.bluePrimary};
              font-size: 1.25rem;
              font-weight: bold;
              margin-top: 2rem;
              opacity: 0.9;
              padding: 1rem;
            }
            .small-title {
              color: ${colors.white};
              font-size: 0.875rem;
              font-weight: bold;
              margin-top: 2rem;
            }
            .container :global(.input-container) {
              width: 50%;
            }
            .title :global(.save) {
              margin: 0;
              position: absolute;
              right: 0;
              top: 0;
            }
          `}</style>
        </div>
    );
}

export default ManageDocument;

export const Route = createFileRoute('/_authenticated/settings/document/manage')({ component: ManageDocument })
